import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { withViewport } from '../../util/contextHelpers';

import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  ExternalLink,
  NamedLink,
  ContactPreFooter,
} from '../../components';
import heroImage from '../../assets/systam-success-story-banner.webp';

import quoteImg from '../../assets/systam-success-story-quote.webp';
import quoteImg2 from '../../assets/systam-success-story-quote2.webp';

import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import css from './SuccessStorySystamPage.css';

export const SuccessStorySystamPageComponent = props => {
  const { intl, scrollingDisabled, viewport } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const schemaTitle = intl.formatMessage({ id: 'SuccessStorySystam.schemaTitle' });
  const schemaDescription = intl.formatMessage({
    id: 'SuccessStorySystam.schemaDescription',
  });

  const handleShowSpaceHome = () => {
    if (typeof window === 'object') {
      window.Intercom('showSpace', 'home');
    }
  };

  const MAX_MOBILE_SCREEN_WIDTH = 962;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="SuccessStorySystamPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroSection}>
            <div className={css.heroSectionLeft}>
              <div className={css.heroSectionBreadcrumbs}>
                <NamedLink name="SuccessStoriesPage">
                  <FormattedMessage id="SuccessStorySystam.heroBreadcrumbs1" />
                </NamedLink>
                <FormattedMessage id="SuccessStorySystam.heroBreadcrumbs2" />
                <FormattedMessage id="SuccessStorySystam.heroBreadcrumbs3" />
              </div>
              {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                <ExternalLink href="https://systam.fi/" className={css.heroSectionMobile}>
                  <img
                    src={heroImage}
                    alt="Hero"
                    className={css.proInfoSectionContentImage}
                    loading="lazy"
                  />
                </ExternalLink>
              ) : null}
              <div className={css.heroSectionTitle}>
                <FormattedMessage id="SuccessStorySystam.heroTitle" />
              </div>
              <div className={css.heroSectionText}>
                <FormattedMessage id="SuccessStorySystam.heroText" />
              </div>
              <div className={css.heroSectionTags}>
                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStorySystam.heroTag1" />
                </div>

                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStorySystam.heroTag2" />
                </div>
              </div>
            </div>
            {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
              <ExternalLink href="https://systam.fi/" className={css.heroSectionRight}>
                <img
                  src={heroImage}
                  alt="Hero"
                  className={css.proInfoSectionContentImage}
                  loading="lazy"
                />
              </ExternalLink>
            ) : null}
          </div>
          <div className={css.sections}>
            <div className={css.contentSection}>
              <div className={css.contentSectionContent}>
                <div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionTitle1" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStorySystam.contentSectionParagraph11"
                        values={{
                          a: chunks => (
                            <a
                              href="https://systam.fi/"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1683A3', fontWeight: 600 }}
                            >
                              {chunks}
                            </a>
                          ),
                        }}
                      />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph12" />
                    </p>
                  </article>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionTitle2" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStorySystam.contentSectionParagraph21"
                        values={{
                          b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                        }}
                      />
                    </p>
                  </article>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionTitle3" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph31" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph32" />
                    </p>
                  </article>
                  <div className={css.articleBlockWithBGWithImage}>
                    <img
                      src={quoteImg}
                      alt="Anu Luoma"
                      className={css.articleBlockWithBGWithImageImage}
                      loading="lazy"
                    />
                    <div className={css.articleBlockWithBGWithImageContent}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph33Quote" />
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph33Name" />
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph33Company" />
                    </div>
                  </div>
                  {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                    <div className={css.contentSectionCTAmobile}>
                      <div className={css.contentSectionCTAtitle}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                      </div>
                      <div className={css.contentSectionCTAtext}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                      </div>
                      <div className={css.contentSectionCTAbutton}>
                        <ExternalLink
                          className={css.contentSectionContactButton}
                          onClick={handleShowSpaceHome}
                        >
                          <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                        </ExternalLink>
                      </div>
                    </div>
                  ) : null}
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionTitle4" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStorySystam.contentSectionParagraph41"
                        values={{
                          b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                        }}
                      />
                    </p>
                  </article>
                  <div className={css.articleBlockWithBGWithImage}>
                    <img
                      src={quoteImg2}
                      alt="Emmi Kurru"
                      className={css.articleBlockWithBGWithImageImage}
                      loading="lazy"
                    />
                    <div className={css.articleBlockWithBGWithImageContent}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph42Quote" />
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph42Name" />
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph42Company" />
                    </div>
                  </div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionTitle5" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph51" />
                    </p>
                  </article>
                  <div className={css.articleBlockWithBGWithImage}>
                    <img
                      src={quoteImg2}
                      alt="Emmi Kurru"
                      className={css.articleBlockWithBGWithImageImage}
                      loading="lazy"
                    />
                    <div className={css.articleBlockWithBGWithImageContent}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph52Quote" />
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph52Name" />
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph52Company" />
                    </div>
                  </div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionTitle6" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph61" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph62" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionParagraph63" />
                    </p>
                  </article>
                  <div className={css.articleSectionResults}>
                    <div className={css.articleSectionResultsTitle}>
                      <FormattedMessage id="SuccessStorySystam.contentSectionResultsTitle" />
                    </div>
                    <ul className={css.articleSectionResultsList}>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage
                          id="SuccessStorySystam.contentSectionResultsListItem1"
                          values={{
                            b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                          }}
                        />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage
                          id="SuccessStorySystam.contentSectionResultsListItem2"
                          values={{
                            b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                          }}
                        />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage
                          id="SuccessStorySystam.contentSectionResultsListItem3"
                          values={{
                            b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                          }}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
                <div className={css.contentSectionCTAbar}>
                  <div className={css.contentSectionCTA}>
                    <div className={css.contentSectionCTAtitle}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                    </div>
                    <div className={css.contentSectionCTAtext}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                    </div>
                    <div className={css.contentSectionCTAbutton}>
                      <ExternalLink
                        className={css.contentSectionContactButton}
                        onClick={handleShowSpaceHome}
                      >
                        <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                      </ExternalLink>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <ContactPreFooter />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

SuccessStorySystamPageComponent.defaultProps = {
  scrollingDisabled: false,
};

const { number, shape } = PropTypes;

SuccessStorySystamPageComponent.propTypes = {
  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired, // from injectIntl
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SuccessStorySystamPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(SuccessStorySystamPageComponent);

export default SuccessStorySystamPage;
